import { useEffect } from 'react';
import { logError } from '@betty/toolkit/logging';
import { processPaymentUrl } from '../../utils/payments';
import { PaymentResultHandler } from './usePaymentResult.types';

const usePaymentResult = (onPaymentResult: PaymentResultHandler) => {
  useEffect(() => {
    const onMessage = (event: MessageEvent<string>) => {
      if (window.origin !== event.origin || typeof event.data !== 'string') {
        return;
      }

      try {
        const { type, location } = JSON.parse(event.data) || {};

        if (type === 'PAYMENT_RESULT' && typeof location === 'string') {
          const { transactionId } = processPaymentUrl(location) || {};

          onPaymentResult(transactionId);
        }
      } catch (e) {
        logError('Parse iframe message error', e);
      }
    };

    window.addEventListener('message', onMessage);

    return () => window.removeEventListener('message', onMessage);
  }, [onPaymentResult]);
};

export default usePaymentResult;
